import Home from "./Home"
import { BrowserRouter, Routes, Route } from "react-router-dom";

const AppRouters = () => {
    return(
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/about" element={<Home />} />
            <Route path="/services" element={<Home />} />
            <Route path="/portfolio" element={<Home />} />
            <Route path="/blog" element={<Home />} />
            <Route path="/team" element={<Home />} />
            <Route path="/contact" element={<Home />} />
        </Routes>

    )
}

export default AppRouters